import { apiUrl } from "../../../config";

export async function postJson(url, body) {
  const res = await fetch(url, {
    method: "POST",
    credentials: "include",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error("Failed to save");
  return res.json();
}

export const API = {
  receiver: { save: `${apiUrl}/material_management/material_emissions` },
  donor: { save: `${apiUrl}/api/ghg-credit/emissions` },
};
